import { useAuthContext } from '@/hooks/use-auth-context'
import { Button, Menu } from '@mantine/core'
import Link from 'next/link'
import { dropdownItemClass } from './nav-link-styles'
import { Icon } from '@/components/icon'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { OrganizationTypes } from '@/api/generated/model'

export function ClaimManagementDropdown() {
  const { organization } = useAuthContext()

  return (
    <Menu shadow="md" width={170} position="bottom-start">
      <Menu.Target>
        <Button
          variant="transparent"
          c="white"
          rightSection={<Icon icon={faChevronDown} size={10} />}
        >
          Claim Management
        </Button>
      </Menu.Target>
      <Menu.Dropdown>
        {organization?.OrganizationType == OrganizationTypes.Distributor && (
          <Menu.Item
            component={Link}
            href="/claim-management/transactions"
            className={dropdownItemClass}
          >
            Transactions
          </Menu.Item>
        )}
        <Menu.Item
          component={Link}
          href="/claim-management/claims"
          className={dropdownItemClass}
        >
          Claims
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}
